<template>
  <v-container id="tour-container" pa-0>
    <fdi-restaurant-navigation :restaurants="restaurants"></fdi-restaurant-navigation>
    <transition name="fade">
      <fdi-step
        v-for="(step, i) in steps"
        :key="'step-'+ i+1"
        v-if="i==currentStepIndex"
        :step="step"
      ></fdi-step>
      <!-- <fdi-step :step="steps[currentStepIndex]" /> -->
    </transition>
  </v-container>
</template>

<script>
import TopNavContainer from "./TopNavContainer";
import StepComponent from "../Step/StepComponent";

export default {
  name: "tour-container",
  components: {
    "fdi-restaurant-navigation": TopNavContainer,
    "fdi-step": StepComponent
  },
  computed: {
    tourContainerHeight() {
      return this.$store.getters.appInnerHeight - 110;
    },
    steps() {
      return this.$store.getters.currentRestaurantStepObjects;
    },
    currentStepIndex() {
      return this.$store.getters.currentStepIndex;
    },
    restaurants() {
      return this.$store.getters.restaurants;
    }
  },
  mounted() {}
};
</script>

<style scoped>
#tour-container {
  height: 100vh;
  width: 100%;
  background-image: url("../../assets/backgrounds/paper_bkgd.png");
  background-size: auto 100%;
  background-position: center;
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
